import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PopupService } from '../../../services/shared/popup.service';
import { CurrencyFormat } from '../../../pipes/currencyFormat.pipe';
import { CarrierService } from '../../../services/carrier.service';
import { ApplicationService } from '../../../services/application.service';
import { PermitService } from '../../../services/permit.service';
import { VehicleService } from '../../../services/vehicle.service';
import { environment } from '../../../../environments/environment';
import { AppVehicleComponent } from '../shared/app-vehicle/app-vehicle.component'

@Component({
  selector: 'app-view-permit-application',
  templateUrl: './view-permit-application.component.html',
  styleUrls: ['./view-permit-application.component.css'],
  providers: [CurrencyFormat]
})
export class ViewPermitApplicationComponent implements OnInit {

  dataCntrl: any = { applicationID:-1, permittypeSelected:false, selectedtype:'', disableTypes:false, processStarted:false, currentTab:'', formValid:false, isViewEditControl:true, carrier: {}, application: {}, permit: {}, permittype: {}, vehicles:[]};
  editMode: boolean;
  StartComplete:boolean;
  VehicleComplete:boolean;
  loadchild:boolean;
  canSave:boolean;
  canSubmit:boolean;
  pageload:boolean;
  tabload: boolean;

  activeTab = 'permitype';
  disableTabs:boolean = true;
  myreference: '';
  username: any;
  message = '';

  constructor(private router: Router, private activeRoute: ActivatedRoute, private showModal:PopupService,
    private carrierService: CarrierService, public currformat: CurrencyFormat,
    public applicationService: ApplicationService, public permitService: PermitService,
    public vehicleService: VehicleService) { }

  ngOnInit() {
    this.activeRoute.params.subscribe((params: Params) => {
      this.dataCntrl.applicationID = params['id'];
      this.editMode = params['edit'];
    });
    this.dataCntrl.currentTab = 'permitype';
    this.getApplicationData();
    this.username = environment.authWebApi.userData.User.Username;

  }

  getApplicationData(){
    this.pageload = true;
    this.applicationService.getById(this.dataCntrl.applicationID).subscribe(result => {
      //this.dataCntrl.carrier = result.carrier;
      this.dataCntrl.application = result;
      //this.dataCntrl.permit = result.permit;
      //this.dataCntrl.permittype = result.permit_type;
      //this.dataCntrl.vehicles = result.vehicle;
      this.pageload = false;
      this.loadchild == true;
    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }

  getCarrier(){
    this.pageload = true;
    this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
      this.setCarrierData(result);
      this.pageload = false;
    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }

  setCarrierData(data){
    data.account_balance = this.currformat.transform(parseFloat(data.account_balance));
    this.dataCntrl.carrier = data;
    this.dataCntrl.application.carrier_id = data.id;
    this.dataCntrl.application.person_id = data.person_id;
  }

  tabChanged(tab){
    this.dataCntrl.currentTab = tab;
    this.disableButtons();
    switch (tab) {
      case 'permitype': {
        this.canSave = this.dataCntrl.permittypeSelected ? true : false;
        this.activeTab = tab;
        break;
      }
      case 'vehicle': {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
      case 'route': {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
      case 'motivation': {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
      case 'uploads': {
        this.canSave = true;
        this.activeTab = tab;
        break;
      }
    }
  }

  onSubmit(){}

  disableButtons(){
    this.canSave = false;
    this.canSubmit = false;
  }

  onStart(){
    this.saveApplication();
    this.canSave = true;
    this.dataCntrl.processStarted = true;
    this.disableTabs = this.dataCntrl.permittypeSelected ? false : true;
    this.activeTab = 'vehicle';
    this.dataCntrl.currentTab = 'vehicle';
  }

  onCancel(){
    if(this.dataCntrl.processStarted==true && this.dataCntrl.application.id==undefined){
      this.showModal.showConfirm('Cancel Application', 'Are you sure you want to cancel?', `Your application has not been saved. If you continue to cancel without saving, you will loose all your data.`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.router.navigateByUrl(`/carrier/permit/application/${this.dataCntrl.application.carrier_id}`);
        } else {
          return;
        }
      });
     }else{
      this.router.navigateByUrl(`/carrier/permit/application/${this.dataCntrl.application.carrier_id}`);
     }
  }

  onSave(){
    switch (this.dataCntrl.currentTab) {
      case 'permitype': {
        if(this.dataCntrl.application.id == undefined){
          this.saveApplication();
        }else{
          this.showModal.showAlert('Save Application','Application saved successfully');
        }
        break;
      }
      case 'vehicle': {
        this.saveVehicles();
        break;
      }
      case 'route': {
        this.saveRoute();
        break;
      }
      case 'motivation': {
        this.saveMotivation();
        break;
      }
      case 'uploads': {
        if(this.dataCntrl.application.id == undefined){
          this.saveApplication();
        }else{
          this.showModal.showAlert('Save Application','Application saved successfully');
        }
        break;
      }
    }
  }

  saveApplication() {
    this.tabload = true;
    this.dataCntrl.application.date_modified = this.dataCntrl.application.date_created = new Date();
    this.dataCntrl.application.user_modified = this.dataCntrl.application.user_created = this.username;
    this.applicationService.postApplication(this.dataCntrl.application)
      .subscribe((result:any) => {
        this.dataCntrl.application = result;
        this.dataCntrl.permit.permit_type_id = result.permit_type_id;
        this.dataCntrl.permit.application_id = result.id;
       this.savePermit();
      },
        error => {
          this.tabload = false;
          this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
          return;
        });
  }

  savePermit(){
    //console.log(this.dataCntrl)
    this.dataCntrl.permit.date_modified = this.dataCntrl.permit.date_created = new Date();
    this.dataCntrl.permit.user_modified = this.dataCntrl.permit.user_created = this.username;
    this.dataCntrl.permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee ;
    this.dataCntrl.permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee ;
    this.permitService.postPermit(this.dataCntrl.permit)
    .subscribe(result => {
      this.dataCntrl.permit = result;
      this.tabload = false;
    },
      error => {
        this.tabload = false
        this.showModal.showError('Save Application', 'Failed to save application. If the problem persist, please contact system administrator.', error);
        return;
      });
  }

  saveVehicles(){
    this.tabload = true;
    this.dataCntrl.vehicles.forEach(element => {
      element.permit_id = this.dataCntrl.permit.id;
      element.date_modified = element.date_created = new Date();
      element.user_modified = element.user_created = this.username;
    });
      if(this.dataCntrl.application.id == undefined){
       this.saveApplication();
      }else{
        this.vehicleService.postVehicle(this.dataCntrl.vehicles)
        .subscribe(result => {
        this.dataCntrl.vehicles = result;
       this.updateVehiclelist(result);
       this.showModal.showAlert('Save Application','Vehicles saved successfully');
        },
        error => {
          this.tabload = false;
        this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
        });
      }
  }

  updateVehiclelist(data){
    //console.log(data)
    this.tabload = false;
  }

  saveRoute(){
    this.tabload = true;
    if(this.dataCntrl.application.id == undefined){
      this.saveApplication();
    }else{
      this.applicationService.putApplication(this.dataCntrl.application)
      .subscribe(result => {
        this.dataCntrl.application = result;
        this.tabload = false;
        this.showModal.showAlert('Save Application','Route saved successfully');
        },
        error => {
          this.tabload = false;
        this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
        });
    }
  }

  saveMotivation(){
    this.tabload = true;
    if(this.dataCntrl.application.id == undefined){
      this.saveApplication();
    }else{
      this.applicationService.putApplication(this.dataCntrl.application)
      .subscribe(result => {
        this.dataCntrl.application = result;
        this.tabload = false;
        this.showModal.showAlert('Save Application','Motivation saved successfully');
        },
        error => {
          //console.log(error)
          this.tabload = false;
        this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
        });
    }
  }
}
